import { useEffect, useState } from "react";

/** Detecta o shell desktop (Tauri) apos a hidratacao, para nao divergir do SSR. */
export function useIsTauri(): boolean {
    const [isTauri, setIsTauri] = useState(false);

    useEffect(() => {
        setIsTauri("__TAURI_INTERNALS__" in window);
    }, []);

    return isTauri;
}
